import { render, staticRenderFns } from "./ShowAcademic.vue?vue&type=template&id=8e6b0ffe&scoped=true"
import script from "./ShowAcademic.vue?vue&type=script&lang=js"
export * from "./ShowAcademic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b0ffe",
  null
  
)

export default component.exports